import * as Types from '../../../../baseType';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EnsureTossPaymentsDoneQueryVariables = Types.Exact<{
  data: Types.SingleIdInput;
}>;


export type EnsureTossPaymentsDoneQuery = { __typename?: 'Query', ensureTossPaymentsDone: { __typename?: 'OkResponse', ok: number } };


export const EnsureTossPaymentsDoneDocument = gql`
    query ensureTossPaymentsDone($data: SingleIDInput!) {
  ensureTossPaymentsDone(data: $data) {
    ok
  }
}
    `;

/**
 * __useEnsureTossPaymentsDoneQuery__
 *
 * To run a query within a React component, call `useEnsureTossPaymentsDoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnsureTossPaymentsDoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnsureTossPaymentsDoneQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEnsureTossPaymentsDoneQuery(baseOptions: Apollo.QueryHookOptions<EnsureTossPaymentsDoneQuery, EnsureTossPaymentsDoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnsureTossPaymentsDoneQuery, EnsureTossPaymentsDoneQueryVariables>(EnsureTossPaymentsDoneDocument, options);
      }
export function useEnsureTossPaymentsDoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnsureTossPaymentsDoneQuery, EnsureTossPaymentsDoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnsureTossPaymentsDoneQuery, EnsureTossPaymentsDoneQueryVariables>(EnsureTossPaymentsDoneDocument, options);
        }
export type EnsureTossPaymentsDoneQueryHookResult = ReturnType<typeof useEnsureTossPaymentsDoneQuery>;
export type EnsureTossPaymentsDoneLazyQueryHookResult = ReturnType<typeof useEnsureTossPaymentsDoneLazyQuery>;
export type EnsureTossPaymentsDoneQueryResult = Apollo.QueryResult<EnsureTossPaymentsDoneQuery, EnsureTossPaymentsDoneQueryVariables>;